<template>
  <div class="orderaction-list">
    <br/>
    <div :style="{ 'margin-bottom': toolbarMarginBottom }">
      <Toolbar>
        <template #left>
          <h1><v-icon large v-on:click="toggleZone">mdi-alert-decagram</v-icon>{{$t('order.historique')}}</h1>
        </template>
        <v-icon v-if="isZoneVisible" large v-on:click="toggleZone">mdi-eye</v-icon>
        <v-icon v-else large v-on:click="toggleZone"> mdi-eye-off </v-icon>
      </Toolbar>
    </div>

    <v-container  v-if="isZoneVisible" grid-list-xl fluid >
      <v-layout row wrap>

        <v-flex lg12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @click:row="showHandler"
            @contextmenu:row="showHandlerExt"
            @update:options="onUpdateOptions"
          >
          <template slot="item.date" slot-scope="{ item }">
            {{ formatDateTime(item['date'], 'long') }}
          </template>

          <template slot="item.titre" slot-scope="{ item }">
            <span class="cursorpointer" @click="showHandler(item)">{{ item.titre }}</span>
          </template>

          <template slot="item.type" slot-scope="{ item }">
            <v-chip  class="ma-1 font-weight-bold"  label  color="secondary">{{ item['type'].name }}</v-chip>
          </template>

          <template  slot="item.content" slot-scope="{ item }">
            <pre class="truncate"> {{ item.content }}</pre>
            <pre class="truncate"> {{ item.comment }}</pre>
          </template>       
        
          
          
          <template slot="item.file" slot-scope="{ item }">
              <v-btn
                  v-if="item['file']"
                  color="secondary"
                  fab
                  small
                  @click="downloadFileList(item['id'],item['@entity'],item['file'].filePath)"
              >
                <v-icon      
                  dark
                  >mdi-download
                </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from "../../mixins/FileMixin";
import Toolbar from "../Toolbar.vue";
import AccessMixin from "../../mixins/AccessMixin";

const servicePrefix = 'OrderAction';
export default {
name: 'OrderActionList',
servicePrefix,
components: {
  Toolbar,
},
props : ['parentOrder'],
data() {
  return {
    headers: [
      { text: this.$t('global.date'), value: 'date' , width: 10},
      { text: this.$t('orderaction.titre'), value: 'titre', width: 100},
      { text: this.$t('orderaction.type'), value: 'type', sortable: false, width: 20},
      { text: this.$t('orderaction.content'), value: 'content', sortable: false},  
     // { text: this.$t('orderaction.comment'), value: 'comment', sortable: false},  
      { text: this.$t('orderaction.file'), value: 'file', sortable: false, width: 10},
    ],
    selected: [],
    footer: {
      'itemsPerPageText': "",
    },
    options: {sortBy : ['date'], sortDesc : [true]},
    parentAdd: {
      '@id' : this.$route.params.id,
    },
    filters: {
      'orderRef' : this.$route.params.id,
    },
    isZoneVisible: false,
    toolbarMarginBottom: '20px',
  };
  
},
mixins: [ListMixin,  FileMixin, AccessMixin],
computed: {
  ...mapFields('orderaction',{
    deletedItem: 'deleted',
    error: 'error',
    isLoading: 'isLoading',
    resetList: 'resetList',
    totalItems: 'totalItems',
    view: 'view'
  }),

  ...mapGetters('orderaction', {
    items: 'list'
  }),
},
methods: {
  ...mapActions('orderaction', {
    getPage: 'fetchAll',
  }),
  showHandler(item) {
    this.$router.push({
      name: `OrderActionShow`,
      params: { id: item['@id'] }
    });
  },
  toggleZone() {
    this.isZoneVisible = !this.isZoneVisible
  },
}
}
</script>
<style>
.truncate {
max-width: auto;
word-wrap: break-word;
white-space: pre-wrap;
overflow: hidden;
display: block;
}

</style>
